const semanticClassNames = {
  inputContainer: 'input-area__input-container',
} as const;

export default semanticClassNames;
